// extracted by mini-css-extract-plugin
export var textInput = "_f3-0";